/*
 * Guide des tailles (popup « Guide des tailles » de la fiche produit).
 * Le thème recharge le sélecteur de variantes à chaque choix de pointure : un script
 * placé dans le popup ne se relance pas, et le guide s'ouvrait vide. Ce fichier prépare
 * chaque guide présent dans la page, y compris ceux ajoutés après coup.
 * L'onglet ouvert par défaut suit le produit (data-default-cat : homme / femme / enfant).
 */
(() => {
  // [EU, UK, US, cm]
  var DATA = {
    homme: [
      [36,2.5,3,23],[37,3,3.5,23.5],[38,4,4.5,24],[39,5.5,6,24.5],[40,6,6.5,25],
      [41,6.5,7,25.5],[42,7,7.5,26],[43,8,8.5,26.5],[44,9,9.5,27],[45,9.5,10,27.5],
      [46,10.5,11,28],[47,11,11.5,28.5],[48,12,12.5,29],[49,12.5,13,29.5],[50,13.5,14,30]
    ],
    femme: [
      [35,2,4,22],[36,3,5,22.5],[37,4,6,23],[38,5,7,23.5],[39,6,8,24],
      [40,6.5,8.5,24.5],[41,7.5,9.5,25],[42,8.5,10.5,25.5]
    ],
    enfant: [
      [21,4.5,5,13],[22,5,5.5,13.5],[23,6,6.5,14.3],[24,6.5,7,15],[25,7.5,8,15.6],
      [26,8,8.5,16.3],[27,9,9.5,16.9],[28,10,10.5,17.6],[29,10.5,11,18.3],[30,11.5,12,18.9],
      [31,12,12.5,19.6],[32,13,13.5,20.3],[33,1,1.5,20.9],[34,1.5,2,21.6],[35,2,2.5,22.3],
      [36,3,3.5,22.9],[37,4,4.5,23.6]
    ]
  };

  function fmt(n) {
    return (Math.round(n * 10) / 10).toString().replace('.', ',');
  }

  function init(root) {
    if (root.dataset.cbInit) return;
    var grid = root.querySelector('.cb-sg-grid');
    var result = root.querySelector('.cb-sg-result');
    if (!grid || !result) return;
    root.dataset.cbInit = '1';

    var catBtns = root.querySelectorAll('.cb-sg-cat-btn');
    var modeBtns = root.querySelectorAll('.cb-sg-mode-btn');
    var panels = root.querySelectorAll('[data-panel]');
    var cmInput = root.querySelector('.cb-sg-measure input');
    var cmBtn = root.querySelector('.cb-sg-measure button');

    var cat = DATA[root.dataset.defaultCat] ? root.dataset.defaultCat : 'homme';
    var state = { cat: cat, mode: 'pointure' };

    function showResult(row) {
      if (!row) {
        result.className = 'cb-sg-result cb-sg-empty';
        result.textContent = 'Choisissez une pointure ci-dessus';
        return;
      }
      var hasUS = state.cat !== 'enfant';
      result.className = 'cb-sg-result';
      var html = 'EU <strong>' + fmt(row[0]) + '</strong>';
      if (hasUS) {
        html += '<span class="cb-sg-sep">=</span>UK <strong>' + fmt(row[1]) + '</strong>';
        html += '<span class="cb-sg-sep">=</span>US <strong>' + fmt(row[2]) + '</strong>';
      }
      html += '<span class="cb-sg-sep">=</span><strong>' + fmt(row[3]) + ' cm</strong>';
      result.innerHTML = html;
    }

    function renderGrid() {
      grid.innerHTML = '';
      showResult(null);
      DATA[state.cat].forEach(function (row) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cb-sg-size-btn';
        btn.textContent = fmt(row[0]);
        btn.addEventListener('click', function () {
          grid.querySelectorAll('.cb-sg-size-btn').forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          showResult(row);
        });
        grid.appendChild(btn);
      });
    }

    function selectCat(name) {
      state.cat = name;
      catBtns.forEach(function (b) { b.classList.toggle('active', b.dataset.cat === name); });
      renderGrid();
      if (cmInput) cmInput.value = '';
    }

    catBtns.forEach(function (btn) {
      btn.addEventListener('click', function () { selectCat(btn.dataset.cat); });
    });

    modeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        modeBtns.forEach(function (b) { b.classList.remove('active'); });
        btn.classList.add('active');
        state.mode = btn.dataset.mode;
        panels.forEach(function (p) {
          p.style.display = (p.dataset.panel === state.mode) ? '' : 'none';
        });
        showResult(null);
      });
    });

    if (cmBtn && cmInput) {
      cmBtn.addEventListener('click', function () {
        var cm = parseFloat((cmInput.value || '').replace(',', '.'));
        if (!cm || cm < 10 || cm > 35) {
          result.className = 'cb-sg-result cb-sg-empty';
          result.textContent = 'Entrez une longueur valide, en cm';
          return;
        }
        var rows = DATA[state.cat];
        var best = rows[0];
        var bestDiff = Math.abs(rows[0][3] - cm);
        rows.forEach(function (row) {
          var diff = Math.abs(row[3] - cm);
          if (diff < bestDiff) { best = row; bestDiff = diff; }
        });
        showResult(best);
      });
    }

    selectCat(cat);
  }

  function scan(node) {
    if (!node.querySelectorAll) return;
    if (node.matches && node.matches('[data-cb-size-guide]')) init(node);
    node.querySelectorAll('[data-cb-size-guide]').forEach(init);
  }

  scan(document);
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) { m.addedNodes.forEach(scan); });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
